import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export default function SubtaskButton({ onClick }) {
  return (
    <Button 
      type="button" 
      variant="ghost" 
      size="sm" 
      onClick={onClick}
      className="text-zinc-900 hover:text-zinc-900 h-8"
    >
      <Plus className="w-3 h-3 mr-1" /> Legg til underoppgave
    </Button>
  );
}